import { createClient } from '@supabase/supabase-js';

// Renseigne ces valeurs dans un fichier .env.local à la racine du projet :
//   REACT_APP_SUPABASE_URL=https://xxxx.supabase.co
//   REACT_APP_SUPABASE_ANON_KEY=eyJ...
// Tant qu'elles sont absentes, le site fonctionne en mode local (localStorage).

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = url && anonKey ? createClient(url, anonKey) : null;
export const isSupabaseConfigured = Boolean(supabase);
